import { ACLCheck } from './Helpers';

/**
 * Returns true when the user should see the simplified Vantage Basic navigation.
 *
 * A user is in this experience when they:
 * - have `read:vantage_basic_experience` (feature audience), and
 * - have `read:early_access` (currently using the new experience), and
 * - do NOT have `read:portofino_full` (Vantage Pro).
 *
 * The `read:portofino_full` guard exists because scopes are a union across every
 * role a user holds, not a property of a single role. A user assigned both the
 * Vantage Basic and Vantage Pro roles — realistic when a client upgrades and the
 * old role is never removed — carries the audience permission alongside Pro's
 * scope. Without this guard a paying Pro user would be downgraded into the
 * simplified navigation. Pro always wins, matching how the rest of the tier logic
 * resolves.
 *
 * `read:early_access_link` is only used to show the opt-in toggle and is not
 * part of this check.
 * The two required scopes are positive, so an empty/unresolved permissions
 * payload is `false`.
 * @returns {boolean} True when the simplified Vantage Basic navigation applies.
 */
export const isSimplifiedBasicNav = (): boolean =>
  ACLCheck(['read:vantage_basic_experience']) && ACLCheck(['read:early_access']) && !ACLCheck(['read:portofino_full']);
